import { MapPin, UserCheck } from "lucide-react";

export default function PublicKnownClient({ info, useSaved, onChoose, onNotMe }) {
  const opt = (val, testid, title, sub) => (
    <button type="button" data-testid={testid} onClick={() => onChoose(val)}
      className={`w-full text-left rounded-2xl border p-4 transition-colors ${useSaved === val ? "border-brand-500 bg-brand-50 ring-1 ring-brand-300" : "border-slate-200 hover:border-brand-300"}`}>
      <div className="flex items-start gap-3">
        <span className={`mt-0.5 w-4 h-4 rounded-full border-2 shrink-0 ${useSaved === val ? "border-brand-600 bg-brand-600 shadow-[inset_0_0_0_2px_white]" : "border-slate-300"}`} />
        <div>
          <div className="font-semibold text-slate-800">{title}</div>
          {sub && <div className="text-sm text-slate-500 mt-0.5">{sub}</div>}
        </div>
      </div>
    </button>
  );

  return (
    <div data-testid="public-known-client" className="space-y-4">
      <div className="rounded-2xl bg-emerald-50 border border-emerald-200 p-4 flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center"><UserCheck className="w-5 h-5" /></div>
          <div>
            <div data-testid="public-welcome" className="font-semibold text-emerald-800">Bonjour {info.first_name} ! Ravi de vous revoir.</div>
            <div className="text-sm text-emerald-700">Vos informations sont déjà enregistrées.</div>
          </div>
        </div>
        <button type="button" data-testid="public-not-me" onClick={onNotMe} className="text-xs text-slate-500 underline hover:text-slate-700 shrink-0">Ce n'est pas moi</button>
      </div>
      <div className="space-y-2">
        {opt(true, "public-use-saved", "Utiliser mon adresse enregistrée",
          <span className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-brand-600" /><span data-testid="public-masked-address">{info.masked_address}, {info.commune_name}</span></span>)}
        {opt(false, "public-other-address", "Livrer à une autre adresse", "Saisissez la nouvelle adresse ci-dessous")}
      </div>
    </div>
  );
}
